import '../../css/shared/MarketHeader.css';

export default function MarketHeader({ label = 'WINNER', cols = ['W1', 'X', 'W2'] }) {
  return (
    <div className="marketheader">
      <div className="market-select">
        <span className="market-select-label">{label}</span>
      </div>
      <div className="market-cols">
        {cols.map((c, i) => (
          <span key={i} className="market-col">{c}</span>
        ))}
      </div>
    </div>
  );
}
